module.exports = __webpack_public_path__ + "img/public/SiteIcons/claimPhotoClose.svg?dfb52a19";